export default __webpack_public_path__ + "static/media/about-1.886e360a.png";